export const whatsappText = (text) => {
  const url = `https://api.whatsapp.com/send?phone=919650271903&text=${encodeURI(
    text
  )}`;
  window.open(url, "_blank");
};
